import { useQuery } from '@tanstack/react-query';
import { candidatesApi } from '../candidatesApi';
import { candidateQueryKeys } from '../queryKeys';

export const useGetCandidateResume = (
  candidateId: string,
  resumeId: string
) => {
  return useQuery({
    queryKey: candidateQueryKeys.resume(candidateId, resumeId),
    queryFn: () => candidatesApi.getCandidateResume(candidateId, resumeId),
  });
};
